'use client'

import clsx from 'clsx'
import { useTranslations } from 'next-intl'

import TaskBackChevronLeftIcon from '@/assets/icons/task-back-chevron-left.svg'
import TaskBackChevronLeftSmIcon from '@/assets/icons/task-back-chevron-left-sm.svg'
import { Link } from '@/i18n/routing'
import { useBackToTasksList } from '@/lib/tasks/tasksListReturn'

import S from './TaskBackLink.module.scss'

type TaskBackLinkProps = {
  className?: string
  /** Without href or onClick: back to the tasks list the fan came from. */
  href?: string
  onClick?: () => void
  onNavigate?: () => void
  ariaLabel?: string
  label?: string
}

export function TaskBackLink({
  className,
  href,
  onClick,
  onNavigate,
  ariaLabel,
  label
}: TaskBackLinkProps) {
  const t = useTranslations('tasksPage.taskBack')
  const resolvedAriaLabel = ariaLabel ?? t('ariaLabel')
  const resolvedLabel = label ?? t('mobileLabel')
  const backToList = useBackToTasksList()
  const handleClick = onClick ?? (href ? undefined : backToList)

  const content = (
    <>
      <TaskBackChevronLeftIcon className={S.icon} aria-hidden />
      <TaskBackChevronLeftSmIcon className={S.iconSm} aria-hidden />
      <span className={S.label}>{resolvedLabel}</span>
    </>
  )

  if (handleClick) {
    return (
      <button
        type="button"
        className={clsx(S.root, className)}
        aria-label={resolvedAriaLabel}
        onClick={handleClick}
      >
        {content}
      </button>
    )
  }

  return (
    <Link
      href={href ?? '/tasks'}
      className={clsx(S.root, className)}
      aria-label={resolvedAriaLabel}
      onClick={onNavigate}
    >
      {content}
    </Link>
  )
}
